<template>    
    <div  v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.programm" class="uk-container uk-container-center uk-text-center uk-margin-top" style="background-image: none;">
        <h1 class="uk-heading uk-margin-top" id="programm">{{this.$store.getters.GetText.programm.title[this.$store.getters.Lang]}}</h1>
        <div v-if="this.$store.getters.GetBlock.notifiacations">
        <div uk-alert class="uk-alert-primary uk-position-z-index-zero" uk-scrollspy="cls:uk-animation-slide-top;">
            <a class="uk-alert-close" uk-close></a>
            <h2>Примечание!</h2>
            <h3>Программа конференции будет сформированна 1 июня.</h3>
        </div>
        <div uk-alert class="uk-alert-danger uk-position-z-index-zero" uk-scrollspy="cls:uk-animation-slide-top;">
            <a class="uk-alert-close" uk-close></a>
            <h2>Примечание!</h2>
            <h3>Уважаемые участники конференции! Обращаем Ваше внимание! В программе везде указано Красноярское время (МСК+4)</h3>
        </div>
        </div>
        

        <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s " uk-grid uk-scrollspy="cls:uk-animation-slide-right;">
            <div class="uk-card-media-left uk-cover-container">
                <img src="../assets/img/programm/conf.jpg" alt="" uk-cover>
                <canvas width="600" height="400"></canvas>
            </div>
            <div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">{{this.$store.getters.GetText.programm.block1_title[this.$store.getters.Lang]}}</h3>
                    <p v-html="this.$store.getters.GetText.programm.block1_subtitle[this.$store.getters.Lang]"></p>
                    <a class="uk-button uk-button-primary uk-position-z-index" .href="this.$store.getters.GetText.programm.src[this.$store.getters.Lang]" target="_blank">{{this.$store.getters.GetText.programm.button[this.$store.getters.Lang]}}</a>
                </div>
            </div>
        </div>

        <!--div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin uk-position-z-index-negative" uk-grid uk-scrollspy="cls:uk-animation-slide-left;">
            <div class="uk-flex-last@s uk-card-media-right uk-cover-container">
                <img src="../assets/img/programm/simp.jpg" alt="" uk-cover>
                <canvas width="600" height="400"></canvas>
            </div>
            <div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">{{this.$store.getters.GetText.programm.block2_title[this.$store.getters.Lang]}}</h3>
                    <p>{{this.$store.getters.GetText.programm.block2_subtitle[this.$store.getters.Lang]}}</p>
                    <a class="uk-button uk-button-primary uk-position-z-index" href="http://conf.ict.nsc.ru/files/conferences/epps2021/651842/Preliminary%20programm_3.pdf">{{this.$store.getters.GetText.programm.button[this.$store.getters.Lang]}}</a>
                </div>
            </div>
        </div-->
    </div> 
</template>